import Cookies from "js-cookie";

// Cookie names — must match what the modules read (see prx_buyerapp-ui Login.tsx)
export const ACCESS_TOKEN_COOKIE = "access-token";
export const REFRESH_TOKEN_COOKIE = "refresh-token";

/**
 * The backend returns a token *object* (`{ access_token, refresh_token, ... }`)
 * which the buyer app stores as a JSON-stringified cookie. Match that shape so
 * the same cookie works across shell + modules on the unified domain.
 */
export interface TokenPayload {
  access_token: string;
  refresh_token?: string;
  expires_in?: number;
  [key: string]: any;
}

export const setTokens = (token: TokenPayload) => {
  Cookies.set(ACCESS_TOKEN_COOKIE, JSON.stringify(token), {
    expires: 7,
    secure: true,
    sameSite: "Strict",
  });
  if (token.refresh_token) {
    Cookies.set(REFRESH_TOKEN_COOKIE, token.refresh_token, {
      expires: 7,
      secure: true,
      sameSite: "Strict",
    });
  }
};

export const getAccessToken = (): string | undefined => {
  const raw = Cookies.get(ACCESS_TOKEN_COOKIE);
  if (!raw) return undefined;
  try {
    const parsed = JSON.parse(raw) as TokenPayload;
    return parsed?.access_token;
  } catch {
    return raw;
  }
};

export const isAuthenticated = (): boolean =>
  Boolean(Cookies.get(ACCESS_TOKEN_COOKIE));

export const clearTokens = () => {
  Cookies.remove(ACCESS_TOKEN_COOKIE);
  Cookies.remove(REFRESH_TOKEN_COOKIE);
  localStorage.removeItem("loginMethod");
};
